import React, { useEffect, useState } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";

import { getAnalytics } from "../../redux/slices/dashboardSlice";
import { SectionHeader, Select } from "../common/ui";
import {
  axisProps,
  gridProps,
  compactNumber,
  ChartTooltip,
  ChartLegend,
  ChartEmpty,
  SeriesGradients,
} from "../common/chart";
import theme from "../../theme";

const SERIES = ["Advertisers", "Campaigns", "Conversions"];

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

const Linechart = () => {
  const dispatch = useDispatch();
  const { analytics } = useSelector((state) => state.dashboard);

  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);

  const years = [];
  for (let i = currentYear; i >= 2020; i--) {
    years.push(i);
  }

  useEffect(() => {
    dispatch(getAnalytics({ year }));
  }, [dispatch, year]);

  // Transforming the API data ("camapigns" is the backend's spelling).
  const data =
    analytics && analytics.camapigns
      ? analytics.camapigns.map((campaign, index) => ({
          name: MONTHS[index],
          Advertisers:
            analytics.advertisers.advertiser[index]?.advertiserCount || 0,
          Campaigns: campaign.campaignCount || 0,
          Conversions:
            analytics.conversions.conversions[index]?.conversioncount || 0,
        }))
      : [];

  const hasData = data.some((point) =>
    SERIES.some((key) => Number(point[key]) > 0)
  );

  return (
    <div style={{ padding: "24px" }}>
      <SectionHeader
        title="Performance analytics"
        subtitle={`Advertisers, campaigns and conversions across ${year}`}
      >
        <Select
          value={year}
          onChange={(event) => setYear(Number(event.target.value))}
          aria-label="Select year"
        >
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </SectionHeader>

      <div style={{ marginBottom: "16px" }}>
        <ChartLegend keys={SERIES} />
      </div>

      {hasData ? (
        <ResponsiveContainer width="100%" height={320}>
          <AreaChart
            data={data}
            margin={{ top: 8, right: 8, left: -12, bottom: 0 }}
          >
            <SeriesGradients keys={SERIES} idPrefix="dash" />
            <CartesianGrid {...gridProps} />
            <XAxis dataKey="name" {...axisProps} />
            <YAxis tickFormatter={compactNumber} {...axisProps} />
            <Tooltip
              cursor={{ stroke: theme.color.border, strokeWidth: 2 }}
              content={<ChartTooltip />}
            />
            {SERIES.map((key, index) => (
              <Area
                key={key}
                type="monotone"
                dataKey={key}
                stroke={theme.chart[index % theme.chart.length]}
                strokeWidth={2}
                fill={`url(#dash-${key})`}
                activeDot={{ r: 4, strokeWidth: 2, stroke: "#fff" }}
              />
            ))}
          </AreaChart>
        </ResponsiveContainer>
      ) : (
        <ChartEmpty>No activity recorded for {year} yet.</ChartEmpty>
      )}
    </div>
  );
};

export default Linechart;
